export function configureTreeCheckboxNodes(treeValues: any, parentKey: string = '') {
    let count = 0;
    return treeValues.map((treeValue: any) => {
        const key = parentKey ? `${parentKey}-${count}` : `${count}`;
        const children = treeValue?.treeValues
        const data = treeValue?.value
        let treeNode: any = {
            key,
            label: treeValue.caption,
        };
        if (data) {
            treeNode = { ...treeNode, data }
        }
        if (children) {
            treeNode = { ...treeNode, children: configureTreeCheckboxNodes(children, key) }
        }
        count++;
        return treeNode
    })
}

export function getAppliedFilterTreeCheckboxValues(treeValues: any, selectedTreeValues: any, appliedFiltersTreeValues: any) {
    treeValues.map((treeValue: any) => {
        if (treeValue.data) {
            let checked = Object.keys(selectedTreeValues).includes(treeValue.key)
            Object.assign(appliedFiltersTreeValues, { [treeValue.data]: checked })
        }
        if (treeValue.children) {
            getAppliedFilterTreeCheckboxValues(treeValue.children, selectedTreeValues, appliedFiltersTreeValues)
        }
    })
}